/* Form factories. Catalogs are no longer kept here — they're loaded from
 * the backend (/catalogs/*) at app startup. */

import { EnglishLevel, Experience, Language, Region } from './constants.js';

export function emptyForm() {
  return {
    role: '',
    experience: Experience.Y1_3,
    skills: [],
    region: Region.MSK,
    remote: false,
    employment: 'full',
    education: '',
    languages: [],
  };
}

export function sampleForm() {
  return {
    role: 'developer',
    experience: Experience.Y3_5,
    skills: ['react', 'typescript', 'redux'],
    region: Region.MSK,
    remote: true,
    employment: 'full',
    education: '',
    languages: [{ language: Language.EN, level: EnglishLevel.B1 }],
  };
}
